const { validator } = require('./validator');
const inOutFormatDecorator = require('./validator').inOutFormatDecorator;

const commonProperties = {
    username: { type: 'string', email: true },
    firstName: {
        type: 'string',
        presence: false,
    },
    lastName: {
        type: 'string',
        presence: false,
    },
    profileEmail: { type: 'string', email: true },
    avatar: {
        type: 'string',
        url: true
    },
    jobCategory: {
        type: 'string',
        presence: false,
        length: {
            minimum: 3,
            maximum: 60
        }
    },
    zip: {
        type: 'alphanum',
        presence: false,
        length: {
            minimum: 5,
            maximum: 10
        }
    },
    address: {
        type: 'alphanum',
        presence: false,
        length: {
            minimum: 3,
            maximum: 60
        }
    },
    city: {
        type: 'string',
        presence: false,
        length: {
            maximum: 60
        }
    },
    state: {
        type: 'string',
        presence: false,
        length: {
            maximum: 60
        }
    },
    country: {
        type: 'string',
        presence: false,
        length: {
            maximum: 60
        }
    },
    lat: {
        presence: false,
        numericality: {
            greaterThanOrEqualTo: -90,
            lessThanOrEqualTo: 90
        }
    },
    lon: {
        presence: false,
        numericality: {
            greaterThanOrEqualTo: -180,
            lessThanOrEqualTo: 180
        }
    }
};

const userUpdate = {
    id: { type: 'ID', presence: true },
    accountEmail: { type: 'string', email: true },
    ...commonProperties
};

const userCreate = {
    id: { type: 'ID' },
    accountEmail: { type: 'string', email: true, presence: true },
    ...commonProperties
};

const userLogin = {
    accountEmail: { type: 'string', email: true, presence: true }
};

const verifyToken = {
    magicToken: { type: 'Token', presence: true }
};

const contactUs = {
    userEmail: { type: 'string', email: true, presence: true },
    fullName: { type: 'string', presence: true },
    subject: { type: 'string', presence: true },
    message: {
        type: 'string',
        presence: true,
        length: {
            minimum: 2,
            maximum: 500
        }
    }
};

module.exports = {
    createUser: {
        schema: userCreate,
        validate: inOutFormatDecorator(validator, userCreate)
    },
    updateUser: {
        schema: userUpdate,
        validate: inOutFormatDecorator(validator, userUpdate)
    },
    loginUser: {
        schema: userLogin,
        validate: inOutFormatDecorator(validator, userLogin)
    },
    verifyToken: {
        schema: verifyToken,
        validate: inOutFormatDecorator(validator, verifyToken)
    },
    contactUs: {
        schema: contactUs,
        validate: inOutFormatDecorator(validator, contactUs)
    }
};
